<template>
  <div class="klickbox-edit-code" v-if="step.kind === 'text'">
    <div class="kp-modular-row clearfix">
      <label class="kp-modular-label label__checkbox">{{ $t('edit.canvas.required_response') }}</label>
      <div class="kp-modular-check pull-right kp-modular-check-without-icon">
        <input
          type="checkbox"
          @change="stepUpdateTextRequired({ event: $event, id: step.id })"
          :checked="step.required">
          <span></span>
      </div>
    </div>
    <div class="kp-modular-row clearfix">
      <label class="kp-modular-label label__checkbox">{{ $t('edit.canvas.multiline_response') }}</label>
      <div class="kp-modular-check pull-right kp-modular-check-without-icon">
        <input
          type="checkbox"
          @change="stepUpdateTextSize({ event: $event, id: step.id })"
          :checked="step.text_size === 'long'">
          <span></span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  computed: mapGetters({
    step: 'stepActive',
  }),
  methods: mapActions([
    'stepUpdateTextRequired',
    'stepUpdateTextSize',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** Text.vue?0f9043dc
 **/